<div class="col-md-12">
  <div class="card card-container">
    <form
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
    <div class="form-title">
      <h1>Réinitialisez le mot de passe</h1>
    </div>
    <div class="mt-3 text-left alert alert-warning">
      Entrez votre nouveau mot de passe
    </div>
      <div class="form-group">
        <label for="token">Code</label>
        <input
          type="text"
          class="form-control"
          name="token"
          [(ngModel)]="form.token"
          required
          #token="ngModel"
        />
        <div class="alert alert-danger" role="alert" *ngIf="token.errors && f.submitted">
          <span>Token est requis!</span>
        </div>
      </div>


      <div class="form-group">
        <label for="newPassword">Mot de passe</label>
        <input
          type="password"
          class="form-control"
          name="newPassword"
          [(ngModel)]="form.newPassword"
          required
          minlength="6"
          #newPassword="ngModel"
        />
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="newPassword.touched && newPassword.errors"
        >
          <div *ngIf="newPassword.errors['required']">Mot de passe requis</div>
          <div *ngIf="newPassword.errors['minlength']">Le mot de passe doit être au moins 6 caractères</div>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Confirmez mot de passe</label>
        <input
          type="password"
          class="form-control"
          name="confirmPassword"
          [(ngModel)]="form.confirmPassword"
          required
          minlength="6"
          #confirmPassword="ngModel"
        />
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="confirmPassword.touched && confirmPassword.errors"
        >
          <div *ngIf="confirmPassword.errors['required']">Mot de passe requis</div>
          <div *ngIf="confirmPassword.errors['matching']">Mot de passe doit être le même</div>
          <div *ngIf="confirmPassword.errors['minlength']">Le mot de passe doit être au moins 6 caractères</div>
        </div>
      </div>

      <div class="form-group mt-3">
        <button class="btn btn-primary btn-block">Envoyer</button>
      </div>

      <div class="form-group">
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="f.submitted"
        >
          Connexion erronée: {{ errorMessage }}
        </div>
      </div>
    </form>
    <div class="mt-3 text-center">
      <a href="connexion" routerLink="/connexion">Retour à la page de Connexion</a>
      <br>
    </div>
  </div>

</div>
